<template>
  <div class="base-title">
    <!-- <img :src="titleImgUrl" alt=""> -->
    <div class="base-title-inner">
      <div class="bti-english"></div>
      <p>{{ titleText }}</p>
      <div class="right_text">{{subText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTitle',
  data() {
    return {}
  },
  props: {
    titleText: {
      type: String,
      default: '楚王世系'
    },
    subText: {
      type: String,
      default: '八代九王'
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  components: {},
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.base-title {
  position: absolute;
  top: 2.92rem;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99;
  pointer-events: none;

  width: 9.7rem;
  height: 2.9rem;
  padding: 0.22rem 0.29rem;
  border: 0.05rem solid #caa05a;
  background-color: #fff;

  .base-title-inner {
    position: relative;

    width: 100%;
    height: 100%;
    border: 0.01rem solid #caa05a;
    background-color: #fff;
    font-size: 1.21rem;
    color: #413f3e;
    font-family: 'shuTi';
    display: flex;
    justify-content: center;
    align-items: center;

    .bti-english {
      position: absolute;
      top: 0.52rem;
      left: 0.45rem;

      width: 0.86rem;
      height: 1.08rem;
      background-image: url('~@/assets/img/origin.png');
      background-size: 100% 100%;
    }
    .right_text {
      writing-mode: vertical-rl;
      width: 1.06rem;
      height: 1.87rem;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      color: #bd8e40;
      font-size: 0.4rem;
      line-height: 1.06rem;
      text-align: center;
      font-family: '楷体', 'KaiTi', '楷体_GB2312', serif;
      border-left: 1px solid #ecd6b2;
    }
    
  }
}
.base-title::before {
  content: '';

  position: absolute;
  bottom: -0.05rem;
  right: 1.08rem;

  width: 0.52rem;
  height: 0.28rem;
  background-image: url('~@/assets/img/box-icon.png');
  background-size: 100% 100%;
  z-index: 1;
}
.base-title::after {
  content: '';
  position: absolute;
  bottom: -0.05rem;

  left: 1.08rem;
  width: 0.52rem;
  height: 0.28rem;
  background-image: url('~@/assets/img/box-icon.png');
  background-size: 100% 100%;
  z-index: 1;
}
</style>